<template>
  <div class="index">
    <page-header titleName="HOME" />
    <div class="index-content content">
      <div class="index-content-topbox">
        <div class="index-content-topbox-l">
          <div class="index-content-topbox-l-1">
            <div class="index-content-topbox-l-1-logo" v-scroll-to="{}">
              <h1>α-Stella</h1>
            </div>
            <p>
                α-Stella は K-Shin07 が 開発したゲームやツールなど<br>
                創作に関することを公開するサイトです。
            </p>
          </div>
          <div class="index-content-topbox-l-2">
            <h1>PROFILE</h1>
            <h2>K-Shin07</h2>
            <p>
                Game Programmer<br>
                C++ / C# / Ruby / JavaScript / PHP / Java / etc...<br>
            </p>
            <p>
                WOLF RPG EDITOR / Visual Studio / Cubase Pro 8 /<br>
                CLIP STUDIO PAINT / Corel Paint Shop Pro X～ / Unity / <br>
                AviUtl / After Effects / Metasequoia / Blender / <br>
                Houdini / Substance Painter / etc...<br>
            </p>
          </div>
        </div>
        <div class="index-content-topbox-r">
          <div class="index-content-topbox-r-triangle">
          </div>
          <div class="index-content-topbox-r-caption">
            <h2>最近公開したもの</h2>
          </div>
          <div class="index-content-topbox-r-board">
            <!-- TODO: Componentization -->
            <div class="index-content-topbox-r-board-caption">
              <img src="../assets/tools/wodistant/ico128.png" alt="">
              <h2>Wodistant</h2>
            </div>
            <div class="index-content-topbox-r-board-content">
              <div class="index-content-topbox-r-board-content-images-1">
                <div class="index-content-topbox-r-board-content-images-1">
                  <img src="../assets/tools/wodistant/tb000.png" alt="">
                </div>
                <div class="index-content-topbox-r-board-content-images-2">
                  <img src="../assets/tools/wodistant/tb001.png" alt="">
                </div>
              </div>
              <div class="index-content-topbox-r-board-content-details">
                <p>
                  WOLF RPG エディターを外部から操作することによって機能を拡張するツール<br><br>
                  前回開いたコモンイベントのスクロール位置を復帰して
                  瞬時に開き直す機能やコモンイベント同士を比較して差分を見る機能などの
                  便利な機能をウディタに追加するツールです。
                </p>
                <a href="./tool/wodistant/" target="_blank">詳細</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-content-banner content">
        <img src="/static/banner.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/pageHeader'
export default {
  title: 'α-Stella',
  components: { PageHeader }
}
</script>

<style scoped lang="scss">
@import '../styles/definitions.scss';
.index {
  &-content {
    margin : 50px auto 0px auto;
    &-topbox {
      position: relative;
      display: flex;
      background-color: $kContentColorMain;
      width: 100%;
      height: 400px;
      white-space: nowrap;
      @media (max-width: $MobileWidth) {
        flex-direction: column;
        white-space: normal;
        height: auto;
      }
      &-l {
        width: 100%;
        flex-direction: column;
        font-size: 14px;
        color: #ffffff;
        &-1 {
          background-color: $kContentColorSub;
          height: 35%;
          padding: 10px 0px 0px 30px;
          &-logo {
            font-size: 20px;
          }
        }
        &-2 {
          padding: 10px 0px 0px 30px;
          height: 65%;
        }
      }
      &-r {
        background-color: #ffffff;
        width: 100%;
        height: 90%;
        color: #57aeff;
        &-triangle {
          position: absolute;
          margin: auto auto auto -150px;
          border-top: 360px solid #ffffff;
          border-right: 150px solid transparent;
          border-left: 150px solid transparent;
          @media (max-width: $MobileWidth) {
            display: none;
          }
        }
        &-caption {
          padding: 10px 0px 0px 0px;
          position: relative;
          text-align:center;
          $tmpFontColor: rgba(34, 34, 34, 0.664);
          text-shadow: 1px 1px 1px $tmpFontColor,
                      -1px 1px 1px $tmpFontColor,
                      1px -1px 1px $tmpFontColor,
                      -1px -1px 1px $tmpFontColor;
        }
        &-board {
          overflow: auto;
          width: 90%;
          height: 80%;
          margin-left: auto;
          margin-right: auto;
          background-color: $kContentColorMain;
          position: relative;
          border-radius: 15px;
          box-shadow: 0px 0 4px 3px rgba(0,0,0,0.4);
          &-caption {
            justify-content: center;
            display: flex;
            flex-direction: row;
            padding: 5px 0px 0px 0px;
            img {
              width: 32px;
              height: 32px;
            }
            h2 {
              padding: 0px 0px 0px 5px;
            }
          }
          &-content {
            font-size: 12px;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            white-space: normal;
            &-images {
              width: 60%;
              &-1 {
                padding: 0px 0px 0px 5px;
                position: relative;
                width: 80%;
              }
              &-2 {
                position: absolute;
                top: 10%;
                left: 30%;
                width: 70%;
              }
            }
            &-details {
              padding: 0px 5px 0px 5px;
              width: 40%;
              a {
                position: relative;
                display: inline-block;
                padding: 0.25em 0.7em;
                margin-left : 10px;
                text-decoration: none;
                color: #FFF;
                background: rgb(46, 148, 196);
                border-radius: 3px;
                transition: 0.2s;
                &:hover {
                  background: rgb(93, 188, 231);
                }
              }
            }
          }
        }
      }
    }

    &-banner {
      margin-top: 20px;
      margin-bottom: 20px;
      justify-content: center;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue